"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
/** Inner view part of the chart widget. Uses a query data loading component
 * to handle loading and continues to display old data if design becomes
 * invalid
 */
class ChartViewComponent extends react_1.default.Component {
    /** Ordinal of update (0, 1, 2...) to ensure using latest */
    updateSeq;
    /** Abort controller for the current data load */
    abortController;
    constructor(props) {
        super(props);
        this.updateSeq = 0;
        this.state = {
            validDesign: null, // last valid design
            data: null, // data for chart
            dataLoading: false, // True when loading data
            dataError: null, // Set when data loading returned error
            cacheExpiry: props.dataSource.getCacheExpiry(), // Save cache expiry to see if changes
            showErrorDetails: false
        };
    }
    componentDidMount() {
        this.updateData();
    }
    componentDidUpdate(prevProps) {
        if (!lodash_1.default.isEqual(prevProps.design, this.props.design) ||
            !lodash_1.default.isEqual(prevProps.filters, this.props.filters) ||
            this.props.dataSource.getCacheExpiry() !== this.state.cacheExpiry ||
            prevProps.refreshKey !== this.props.refreshKey) {
            // Save new cache expiry
            this.setState({ cacheExpiry: this.props.dataSource.getCacheExpiry() });
            this.updateData();
        }
    }
    updateData() {
        // Clean design first (needed to validate properly)
        const design = this.props.chart.cleanDesign(this.props.design, this.props.schema);
        // If design is not valid, do nothing as can't query invalid design
        const errors = this.props.chart.validateDesign(design, this.props.schema);
        if (errors) {
            return;
        }
        this.updateSeq += 1;
        if (this.abortController) {
            this.abortController.abort("Aborting previous data load");
        }
        // Set loading data after interval to prevent unnecessary refresh
        const dataLoadingTimeout = setTimeout(() => {
            this.setState({ dataLoading: true });
        }, 100);
        // Store updateSeq to check if latest
        const loadingUpdateSeq = this.updateSeq;
        this.abortController = this.props.widgetDataSource.getData(design, this.props.filters || [], (error, data) => {
            // Prevent setting data loading if ready
            clearTimeout(dataLoadingTimeout);
            // Only update if latest
            if (loadingUpdateSeq == this.updateSeq) {
                // Clear the abort controller
                this.abortController = undefined;
                this.setState({ dataLoading: false, dataError: error, data, validDesign: design });
            }
        }) ?? undefined;
    }
    renderSpinner() {
        return R("div", { style: { position: "absolute", bottom: "50%", left: 0, right: 0, textAlign: "center", fontSize: 20 } }, R("i", { className: "fa fa-spinner fa-spin" }));
    }
    renderError() {
        const errorText = (this.state.dataError.message || this.state.dataError || "") + "";
        const isTimeout = errorText.match(/timeout/) != null;
        return R("div", { style: { marginTop: 20, textAlign: "center" } }, R("div", { className: "text-danger" }, isTimeout ?
            T `This widget has timed out. Placing widgets across console tabs instead of having them all in one dashboard can improve performance.`
            : T `There was an error loading data for this widget.`), R("div", { className: "mt-3" }, R("button", {
            className: "btn btn-secondary btn-sm",
            disabled: this.state.dataLoading,
            onClick: () => {
                this.updateData();
            }
        }, R("i", { className: "fas fa-redo" }), T `Try again`)), R("button", {
            className: "btn btn-link btn-sm mt-2",
            onClick: () => this.setState({ showErrorDetails: !this.state.showErrorDetails })
        }, this.state.showErrorDetails ? T `Hide details` : T `Show details`), this.state.showErrorDetails ?
            R("div", { style: { marginTop: 10, fontSize: 10 } }, `Error: ${this.state.dataError.message || this.state.dataError}`) : null);
    }
    render() {
        const style = { width: this.props.width, height: this.props.height };
        // Faded if loading
        if (this.state.dataLoading) {
            style.opacity = 0.5;
        }
        // If nothing to show, show grey
        if (!this.state.validDesign) {
            // Invalid. Show faded with background
            style.backgroundColor = "#E0E0E0";
            style.opacity = 0.35;
            // Set height to 1.6 ratio if not set so the control is visible
            if (!this.props.height && this.props.width) {
                style.height = this.props.width / 1.6;
            }
        }
        if (this.state.dataError) {
            return this.renderError();
        }
        // Translate design if needed
        const translatedDesign = this.props.onDesignChange || !this.props.translate || !this.state.validDesign ? this.state.validDesign : this.props.chart.translateDesign(this.state.validDesign, this.props.translate);
        return R("div", { style }, translatedDesign
            ? this.props.chart.createViewElement({
                schema: this.props.schema,
                dataSource: this.props.dataSource,
                design: translatedDesign,
                onDesignChange: this.props.onDesignChange,
                data: this.state.data,
                scope: this.props.scope,
                onScopeChange: this.props.onScopeChange,
                width: this.props.width,
                height: this.props.height,
                onRowClick: this.props.onRowClick,
                filters: this.props.filters,
                locale: this.props.locale,
            })
            : undefined, this.state.dataLoading ? this.renderSpinner() : undefined);
    }
}
exports.default = ChartViewComponent;
